import React, {useState} from "react";
import {observer} from "mobx-react-lite";
import classNames from "classnames";

import {ModalConfirm} from "../../../../components/ModalConfirm";
import {CheckBoxIcon} from "../../../../components/icons/CheckBoxIcon";

import './DeleteWithConfirmation.css';

export interface DeleteWithConfirmationProps {
    header: string;
    text: React.ReactNode;
    confirmText: string;
    onConfirm: () => Promise<void>;
    onClose: () => void;
    showConfirmation: boolean;
    conditions: Array<React.ReactNode>;
}

export const DeleteWithConfirmation = observer(({
    header,
    text,
    confirmText,
    onConfirm,
    onClose,
    showConfirmation,
    conditions,
}: DeleteWithConfirmationProps) => {
    const [confirmed, setConfirmed] = useState<boolean[]>(
        conditions.map(() => false)
    );

    const toggleConfirmed = (index: number) =>
        setConfirmed(prev =>
            prev.map((value, i) => (i === index ? !value : value))
        );

    const canConfirm = !showConfirmation || confirmed.every(Boolean);

    return (
        <ModalConfirm
            open={true}
            type={'danger'}
            header={header}
            onConfirm={onConfirm}
            confirmText={confirmText}
            onClose={onClose}
            onCancel={onClose}
            canConfirm={canConfirm}
        >
            <div className="body-large">
                {text}
                {showConfirmation && (
                    <div className="TaskListDelete_CheckList">
                        {conditions.map((label, index) => (
                            <div
                                key={index}
                                className="TaskListDelete_confirmBLock"
                                onClick={() => toggleConfirmed(index)}
                            >
                                <CheckBoxIcon
                                    isChecked={confirmed[index]}
                                    className={classNames({
                                        'TaskListDelete_checkbox': true,
                                        'TaskListDelete_checkbox--checked': confirmed[index],
                                    })}
                                />
                                {label}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </ModalConfirm>
    );
});
